export default {
  cf93069b4586c0fd277168414ee5d7d7: '閲讀',
  '1020f9e7b2aeb6886ab493aa56c3b06f': '思維',
  '3d3e00c72aff381e63f403f71d737a52': '小作家',
  '388571ef5c226dec9827a9fe0ca1c17e': '美育',
  f48e5a926f3f5c3bb011f99ee6fcf960: '英語',
  '89b4688e40307396c2bbca12659eddcc': '文學應用',
  '8cb502dc159831e8833b1dc1df001d15': '商品已下架，即將為您跳轉',
  dd941c299902d0e0b1e0334f77558bb2: '通選商品～',
  e9e2daf47866b5a14e80d5bdf407bed1: '商品已下架，暂时無法購買',
  '4c854b2f98ee4550521093292c5094b1': '立即跳轉（',
  '308d1544aeb074730973a7129a3f4f95': '我知道了'
};
